import jQuery from 'jquery';
import Swiper from "swiper";
import Used from './classes/Used';
import noUiSlider from 'nouislider';
import { debounce } from './utils/treatment';
import { selectUnitByCity } from './functions/selectUnitByCity.js';



window.$ = jQuery;
window.jQuery = jQuery;
window.Swiper = Swiper;
window.noUiSlider = noUiSlider;


// Apenas para o carregamento do arquivo:
import '../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
window.fancybox = fancybox;

const fixedHeaderMobile = $('.header-fixed-mobile')
const fixedFooterMobile = $('.footer-fixed-mobile')
const mainForm = $('.form-main')
const backdropNavbar = $('.backdrop-navbar')
const fixedMenu = $('.fixed-menu')
const btnFormFixed = $('.btn-form-fixed')
const fixedForm = $('.modal-form')
const btnModalFilter = $('.btn-modal-filter')
const modalFilter = $('.modal-filter')
const btnModalFavorites= $('.btn-modal-favorites')
// Menu
const btnMenu = $('.btn-menu')
const menuIcons = $('.menu-list.hidden')
const sideMenu = $('.side-menu')
const fixedFormMenu = $('.form-cotacao')
const btnCotacao = $('.btn-cotacao')
const headerThreshold = 80
const btnMenuMobile = $('.btn-menu-mobile')
const sideMenuMobile= $('.menu-dropdown-mobile')
const btnOpenForms = $('.btn-open-form')

const fixedFooterDesk = $('.footer-fixed')
const fixedHeaderDesktop = $('.header-fixed')

// Import utils functions
import tabs from './functions/tabs'
import carousels from './functions/sliders'
import accordions from './functions/accordions'

$(document).ready(function(){

    // Initialize Tabs
    tabs.tabsInit();

    if(document.querySelector('#used-filter-data')){
      // Used class
      const filters = JSON.parse(document.querySelector('#used-filter-data').getAttribute('data-filter'));
      new Used(filters);
    }

    //Hide Favorite Bar
    // toggleFavoriteBar();
})

// Tabs here
tabs.tabsCreate();

// Swipers Sliders here
carousels.swipersInit()

// Accordions here
accordions.accordionsCreate()

// FUNCTION SHOW UNITS IN FORM ACCORDING TO CITY CHOSEN
selectUnitByCity();

changeTestDriveImage();

function changeTestDriveImage(){
  const myInput = $('select#modelo')
  const imgWrapper = $('form .img-wrapper img')

  myInput.on('change', function (e) {
    const img = $(e.target).find('option:selected').attr('data-image')
    imgWrapper.attr('src', img)
  })

}
// function debounce(func, wait){
//   let timer = null
//   return function(){
//     clearTimeout(timer)
//     timer = setTimeout(func , wait);
//   }
// }



$(window).on('scroll', debounce(
    (e) => {
      console.log(e)
      if(isMobile()){
          toggleElOnScroll(fixedHeaderMobile)
          toggleElOnScroll(fixedFooterMobile)
      } else {
        toggleDisplayOnScroll(fixedHeaderDesktop, headerThreshold)
        toggleElOnScroll(fixedFooterDesk, headerThreshold)
        toggleFormOnScroll(fixedFormMenu, headerThreshold)
      }
    }
  , 60
  )
)

// $(window).on('scroll', function(){

//     if(isMobile()){
//         toggleElOnScroll(fixedHeaderMobile)
//         toggleElOnScroll(fixedFooterMobile)
//     } else {
//         // toggleDisplayOnScroll(btnMenu,headerThreshold)
//         // toggleElOnScroll(menuIcons,headerThreshold)
//         toggleFormOnScroll(fixedFormMenu, headerThreshold)
//     }
// })



function toggleDisplayOnScroll(el, threshold = 50, reverse = false){

  function changeDisplay(el, show, ){
    $(el).css('display', show ? 'flex' : 'none')
  }

  if($(window).scrollTop() > threshold){
      reverse ? changeDisplay(el, 0) : changeDisplay(el, 1)
  } else {
      reverse ? changeDisplay(el, 1) : changeDisplay(el, 0)
  }
}

function toggleElOnScroll(el, threshold = 50, reverse = false){
    if($(window).scrollTop() > threshold){
        reverse ? el.fadeOut() : el.fadeIn()
    } else {
        reverse ? el.fadeIn() : el.fadeOut()
    }
}

function toggleFormOnScroll(el, threshold = 50, reverse = false) {

  if ($(window).scrollTop() > threshold) {

    // to open
    if (btnCotacao.hasClass('active')) {
      btnCotacao.removeClass('active')
      fixedFormMenu.fadeOut('fast')
      // console.log('fechar form')
    }
    else {
      // console.log('form fechado')
    }

  } else {
    // to close
    if (!btnCotacao.hasClass('active')) {
      btnCotacao.addClass('active')
      fixedFormMenu.fadeIn('fast')
      // console.log('Abrir form')
    } else {
      // console.log('form fechado')
    }
  }

}

function isMobile(){
    if($(window).width() > 992){
        return false
    }
    return true
}


// Modals
function popUp(selector){
    selector.fadeIn('fast')
}

function popClose(form){
  if ($('.btn-form-cotation').hasClass('open')){
    $('.btn-form-cotation').toggleClass('open')
  }
    form ? $('.modal-form').fadeOut() : $('.modal-overlay').fadeOut()
    $('body,html').removeClass('scroll-lock')
}
function modalInject(data, target){
  console.log('Rick')
  const {title, img, text} = data
  console.log(title, img, text)
  $(target).find('.promo-title').html(title)
  $(target).find('.promo-img').attr('src', img)
  $(target).find('.promo-text').html(text)

  popUp($(target))

}

$('.jerry').on('click', function(e){
  if(!$(this).hasClass('open')){
    $(this).addClass('open')
    $('.cars-dropdown-c').fadeIn('fast')
  } else{
    $(this).removeClass('open')
    $('.cars-dropdown-c').fadeOut('fast')
  }
});

$('.btn-form-cotation').on('click', function(e){
  const btnMenuIsOpen = $('.btn-menu').hasClass('active')
  const el = $(this)
  const target = $(this).data('target')
  if(btnMenuIsOpen == false){
    // testCall(el)
    $('.modal-overlay').fadeOut()
    if (!$(el).hasClass('open')) {
      $(el).addClass('open')
      popUp($(target))
    }  else{
      $(el).removeClass('open')
      popClose()
    }
  }

});

$('.button-call-filter').on('click', function(e){
  const headerFilterFixedIsOpen = $('.header-filter').hasClass('filter-header-fixed')
  if(!headerFilterFixedIsOpen){
    $('.header-filter').removeClass('d-none')
    $('.header-filter').addClass('filter-header-fixed')
    lockScreenScroll()
    $('.button-call-filter').html('<i class="icon-fechar"></i>Fechar')
  }else{
    $('.header-filter').addClass('d-none')
    $('.header-filter').removeClass('filter-header-fixed')
    lockScreenScroll()
    $('.button-call-filter').html('<i class="icon-lupa"></i>Buscar')
  } 
})

function lockScreenScroll() {
  const elementsDOM = document.querySelector('body, html');
  const lockScreen = document.querySelector('.lock-screen');

  elementsDOM.classList.toggle('scroll-lock');
  lockScreen.classList.toggle('d-flex');
}

$('.btn-open-modal').on('click', function(){
    const el = $(this).data('target')
    const data = $(this).data('json')
    data ? modalInject(data, el) : popUp($(el))
})

$('.modal-overlay, .btn-close-modal, .form-close').on('click',function(e){
  $(e.target).hasClass('form-close') ? popClose(true) : popClose()
}).on('click', '.pop-up-content, .form-main, .main-form', function(event){
  event.stopPropagation();

  if($(event.target).hasClass('btn-privacy')){
    const el = $(event.target).data('target')
    $(el).modal('show')
  }
})

$('.pop-up-content .btn-privacy').on('click', function(){
    const el = $(this).data('target')
    $(el).modal('show')
})

$('.btn-privacy').on('click', function(e){
    e.preventDefault()
})

$('.btn-scroll-top').on('click', function(){
  const model = $(this).data('model')
  if(model)
    $("select[name=servico]").val(model)
  $('html,body').animate({ scrollTop: 0 }, '300')
})

function openDesktopForm() {
  $('.btn-form-cotation').trigger('click')
}

function selectInput(model){
  $("select[name=produto]").val(model)
}


btnOpenForms.on('click', function(){
  console.log('rick')
  const model = $(this).data('model')
  const el = $(this).data('target');
  if(el){
    popUp($(el))
    selectInput(model)
  } else {
    openDesktopForm();
    selectInput(model)
  }
})


// insert current date on inputs type date
const date = new Date();

const day = String(date.getDate()).padStart(2, '0');
const month = String(date.getMonth() + 1).padStart(2, '0');
const year = date.getFullYear();
const currentDate = `${year}-${month}-${day}`;

const inputDate = document.querySelectorAll('input[type="date"]')

inputDate.forEach((input) => {
  input.value = currentDate;
  input.min = currentDate;

  input.addEventListener('blur', () => {
    if(input.value < currentDate) {
      input.value = currentDate;
    }
  });
});




// btnFormFixed.on('click', function(){
//     if(!fixedHeaderDesktop.is(':visible') && !isMobile()){

//         $('html, body').animate({
//             scrollTop: headerThreshold + 1
//         }, 100);
//     }
//     controlModals(btnFormFixed, fixedForm)
// })
// fixedForm.on('click', function(){
//     btnFormFixed.removeClass('active')
// })

btnModalFilter.on('click', function(){
    controlModals(btnModalFilter, modalFilter)
})
modalFilter.on('click', function(){
    btnModalFilter.removeClass('active')
})

function navbarController(el){
  $(el).toggleClass('active')
    if (!$(el).hasClass('active')) {
        // Close
        $(backdropNavbar).fadeOut('fast')
        $(sideMenu).fadeOut('fast')
        // menuIcons.fadeOut('fast')
        $('body,html').removeClass('scroll-lock')
    } else {
        // Open
        $(backdropNavbar).fadeIn('fast')
        $(sideMenu).fadeIn('fast')
        // menuIcons.fadeIn('fast')
        $('body,html').addClass('scroll-lock')
    }
}

btnMenu.on('click', function(){
    // controlModals($(this), fixedMenu)
    // $('.fixed-menu .pop-up-content').toggleClass('active')
    // const formBtn = $('.btn-cotacao');
    // navbarController(btnMenu)
    // formBtn.hasClass('active') ? $(formBtn).trigger('click')  : false
    const btnFormCotationIsOpen = $('.btn-form-cotation').hasClass('open')
    const isRick = $(this).data('rick');
    console.log(isRick, 'isRick 1')
    //Check if is mobile
    if(isMobile()){
      console.log('Mobile')
      if(btnFormCotationIsOpen == false){
        if(!$(this).hasClass('active')){
          $(this).addClass('active')
          if(isRick == 'rick'){
            console.log(isRick, 'isRick 2')
            backdropNavbar.addClass('sanchez')
          }
          backdropNavbar.fadeIn('fast')

          $('body,html').addClass('scroll-lock')
        } else {
          $(this).removeClass('active')
          backdropNavbar.fadeOut('fast')
          $('body,html').removeClass('scroll-lock')


          backdropNavbar.removeClass('sanchez')
        }

      }




    }
    // console.log($(this).hasClass('active'), ': Has class active?')
    //Check if can open side-menu
    if(btnFormCotationIsOpen == false && !isMobile()){
      if(!$(this).hasClass('active')){
        $(this).addClass('active')
        backdropNavbar.fadeIn('fast')


        $('body,html').addClass('scroll-lock')
      } else {
        $(this).removeClass('active')
        backdropNavbar.fadeOut('fast')


        $('body,html').removeClass('scroll-lock')
      }

    }
})

btnMenuMobile.on('click', function(){
  const el = $(this)
  el.toggleClass('active');
  el.hasClass('active')
  ? $('html,body').addClass('scroll-lock') &&
    sideMenuMobile.fadeIn('fast')
  : $('html,body').removeClass('scroll-lock') &&
    sideMenuMobile.fadeOut('fast')
})


$('.btn-cotacao').on('click', function (e) {
  $(this).hasClass('active') ? $('.form-cotacao').fadeOut(250) : $('.form-cotacao').fadeIn(250)

  $(this).toggleClass('active')
})
backdropNavbar.on('click', function (e) {
  // navbarController(btnMenu)
  $(this).removeClass('active')
  backdropNavbar.fadeOut('fast')
  $('body,html').removeClass('scroll-lock')
  $('.btn-menu').removeClass('active')
  backdropNavbar.removeClass('sanchez')
}).on('click', '.side-menu', function(e){
  e.stopPropagation()
})

fixedMenu.on('click', function(){
    btnMenu.removeClass('active')
    $('.fixed-menu .pop-up-content').removeClass('active')
})

//controls special modals interactions
function controlModals(btn, el){
    if(btn.hasClass('active')){
        popClose()
    } else {
        popClose()
        btnMenu.removeClass('active')
        btnModalFilter.removeClass('active')
        btnFormFixed.removeClass('active')
        $('.fixed-menu .pop-up-content').removeClass('active')
        popUp(el)
    }
    btn.toggleClass('active')
}

$('.btn-drop-menu').on('click', function(){
    const btn = $(this)
    btn.toggleClass(`active`)
    btn.find('.submenu').slideToggle('fast')
})

$('.btn-car-dropdown').on('click', function(e){
    e.preventDefault()
    const btn = $(this)
    const parentContainer = btn.data('rel')
    btn.toggleClass('active')
    $(`.${parentContainer} > .cars-dropdown`).slideToggle('fast')
})




//Select box limit and order
$('#limitSelect').change(function () {
    $('#limitCars').val($('#limitSelect').val());
    $('#filterSearch').submit();
});

$('#orderSelect').change(function () {
    $('#orderCars').val($('#orderSelect').val());
    $('#filterSearch').submit();

});

// update upload field text
$(".custom-file-input").on("change", function() {
    const fileName = $(this).val().split("\\").pop()
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName)
});

// modal cupom content
// $('.btn-modal-cupom').on('click', function(){
//     const btn = $(this)
//     const imgSrc = btn.data('img')
//     const title = btn.data('title')
//     const departmentPromo = btn.data('department')
//     $('.modal-cupom img').prop('src', imgSrc)
//     $('.modal-cupom .title').text(title)
//     $('#promoProduct').val(title)
//     $('#departmentPromo').val(departmentPromo)
// })


// redirect timeout - thanks page
const redirectHome = document.querySelector('.redirect-countdown');

if(redirectHome != undefined) {
  let count = 5;

  setInterval(() => {
      if (count >= 0) {
          redirectHome.innerHTML = `${count}s`;
          count--;
      }
  }, 1000)

  setTimeout(() => {
      window.location.href = "/home";
  }, 5500);
}


$('#btn-box1').click(function() {
  window.open('https://bmwrio.com.br/home/', '_blank');
});

$('#btn-box2').click(function() {
  window.open('https://bmriomini.com.br/', '_blank');
});

$('#btn-box3').click(function() {
  window.open('https://bmwriomotorrad.com.br/', '_blank');
});